module.exports = __webpack_public_path__ + "img/2H.ebe43495.png";